import React, { useEffect, useState } from "react";
import { TextInput } from "@/components/toolkit/TextInput";
import { SelectInput } from "@/components/toolkit/SelectInput";

export interface DockerComposeEngineSettings {
    compose_file?: string;
    env_file?: string;
    project_name?: string;
    env?: string;
}

export function DockerComposeSettings(props: {
    settings: DockerComposeEngineSettings;
    onChange: (settings: DockerComposeEngineSettings) => void;
    getMetadata: (settings: DockerComposeEngineSettings) => Promise<any>;
}) {
    const { settings, onChange, getMetadata } = props;
    const [profileOptions, setProfileOptions] = useState<{ value: string; title: string }[] | null>(null);

    useEffect(() => {
        if (!settings.compose_file) {
            setProfileOptions(null);
            return;
        }
        getMetadata(settings).then(meta => {
            if (Array.isArray(meta?.profiles)) {
                setProfileOptions(meta.profiles.map((p: string) => ({ value: p, title: p })));
            } else {
                setProfileOptions([]);
            }
        }).catch(() => setProfileOptions([]));
    }, [settings.compose_file]);

    return (
        <>
            <div className="configure_deploy_env_modal__field">
                <label className="configure_deploy_env_modal__field_label">Compose file</label>
                <TextInput
                    value={settings.compose_file ?? ""}
                    placeholder="docker-compose.yml"
                    onChange={v => onChange({ ...settings, compose_file: v })}
                />
            </div>
            {profileOptions !== null && (
                <div className="configure_deploy_env_modal__field">
                    <label className="configure_deploy_env_modal__field_label">Profile (optional)</label>
                    {profileOptions.length > 0 ? (
                        <SelectInput
                            value={settings.env ?? null}
                            options={[{ value: "", title: "— None —" }, ...profileOptions]}
                            onChange={v => onChange({ ...settings, env: v ?? undefined })}
                        />
                    ) : (
                        <TextInput
                            value={settings.env ?? ""}
                            placeholder="e.g. production"
                            onChange={v => onChange({ ...settings, env: v })}
                        />
                    )}
                </div>
            )}
            <div className="configure_deploy_env_modal__field">
                <label className="configure_deploy_env_modal__field_label">Env file (optional)</label>
                <TextInput
                    value={settings.env_file ?? ""}
                    placeholder=".env"
                    onChange={v => onChange({ ...settings, env_file: v })}
                />
            </div>
            <div className="configure_deploy_env_modal__field">
                <label className="configure_deploy_env_modal__field_label">Project name (optional)</label>
                <TextInput
                    value={settings.project_name ?? ""}
                    placeholder="my-project"
                    onChange={v => onChange({ ...settings, project_name: v })}
                />
            </div>
        </>
    );
}
